var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',_vm._g(_vm._b({attrs:{"to":_vm.toRoute,"exact":"","custom":""},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var href = ref.href;
var navigate = ref.navigate;
var isActive = ref.isActive;
return [_c('li',{class:[
      'slds-nav-vertical__item',
      'bc-nav-vertical__item',
      {
        'slds-is-active': isActive,
        'bc-nav-vertical__item--disabled': _vm.disabled,
      } ]},[_c('a',{staticClass:"slds-nav-vertical__action",attrs:{"href":_vm.disabled ? undefined : href},on:{"click":navigate}},[_vm._t("default"),(_vm.badge)?_c('span',{staticClass:"slds-badge bc-badge slds-col_bump-left"},[_c('span',{staticClass:"slds-assistive-text"},[_vm._v(":")]),_vm._v(_vm._s(_vm.badge)+" "),_c('span',{staticClass:"slds-assistive-text"},[_vm._v(_vm._s(_vm.badgeTitle))])]):_vm._e()],2)])]}}],null,true)},'router-link',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }